import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody29.css';

import clientimg from '../images/case-study-client29.webp'
import outcome from '../images/outcome29.webp'

import sm1 from '../images/cs29so1.webp'
import sm2 from '../images/cs29so2.webp'
import sm3 from '../images/cs29so3.webp'
import sm4 from '../images/cs29so4.webp'



const Casestudybody29 = () => {

    return (
        <>
        <section className='casestudybody29-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A renowned Real Estate Company providing Development Management Service (DMS) in Commercial & Hospitality segments</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought strategic support to optimize their Development Stage-Gate Process, aiming to enhance operational efficiency and streamline project delivery</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody29-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                  
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Triangulation Methodology:</h4>
                          <div className='row border-boxes'>
                          <div className='col-md-4'>
                            <div className='border-box'>
                                <h5>RE Value Chain:</h5>
                                <p>Positioning the client in the RE Value Chain to <span style={{color:"#01C6B2"}}>understand the competitive advantage</span></p>
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className='border-box'>
                                <h5>Core Operations: </h5>
                                <p>Assessed the <span style={{color:"#01C6B2"}}>current business and the company's aspirations</span> to transition into a RE Developer, evaluating their capabilities and growth potential</p>
                            </div>
                          </div>
                
                          <div className='col-md-4'>
                            <div className='border-box'>
                                <h5>Benchmarking Exercise: </h5>
                                <p>Outline the <span style={{color:"#01C6B2"}}>best practices of prominent RE Developers and DMS providers</span> to identify efficient project delivery gateways aligned with industry standards</p>
                            </div>
                          </div>
                
                      </div>
                          
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Workshops:</h4>
                          <p>Conducted <span style={{color:"#01C6B2"}}>site visits and collaborative workshops with key stakeholders</span> from each department to gain an in-depth understanding of project activities and steps involve</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Identification of Key Activities & Considerations: </h4>
                          <p><span style={{color:"#01C6B2"}}>Identified and highlighted key activities at each step</span> involved in the gateways segregated into 3 Stages (Pre-Development, Development & Delivery/Exit Stage)</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Identification of Key Outcomes & Desired State:</h4>
                          <p>Outlined essential deliverables for each gateway, serving as <span style={{color:"#01C6B2"}}>milestones and checkpoints to guide the project</span> and provide a clear roadmap for progress</p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Creation of Optimized Process: </h4>
                          <p>Identified designated process owners and approval authorities with timelines to oversee implementation, management, and decision-making within each gateway, serving as central points of contact for stakeholder coordination and communication, <span style={{color:"#01C6B2"}}>streamlining the entire process reducing inefficiencies</span></p>
                        </div>
                      </div> 
                     
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody29-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A streamlined development gateway process outlining the Project Life-Cycle, mapping the steps to the proposed stage-gate process, identifying the relevant Process Owners & Approval Authority under each Gateway as well as their respective timelines</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody29
